module.exports = __webpack_public_path__ + "img/cbam-yb.852caa74.png";